import React, { useState } from 'react';
import { colors } from '../../../../../../../../../../colorVars';
import { Body3, fontSizes } from '../../../../../../../../../atomic/text/Text';
import style from './FtfcFilterModule.module.css';
import CloseWindowButton from '../../../../../../../../../atomic/buttons/closeWindow/CloseWindowButton';
import { useAlertFormStore } from '../../../../alertFormClass';
import { BoxInput } from '../../../../../../../../../atomic/inputs/boxInput/BoxInput';
import IncrementButton from '../../../../../../../../../atomic/buttons/incrementButton/IncrementButton';
import TextButton from '../../../../../../../../../atomic/buttons/textButton/TextButton';
import { TimeFrameBox } from './TimeFrameBox';
import { observer } from 'mobx-react-lite';
const timeUnitMap = {
  MINUTES: 'Minute',
  DAYS: 'Day',
  WEEKS: 'Week',
  MONTHS: 'Month',
  QUARTERS: 'Quarter',
  YEARS: 'Year',
};

export const FtfcFilterModule = observer(() => {
  const form = useAlertFormStore();
  const [timeUnitSelection, setTimeUnitSelection] = useState('MINUTES');
  const [durationInput, setDurationInput] = useState(1);

  return (
    <div className={`${style.container} noDragTag`}>
      <header className={style.header}>
        <div></div>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          FTFC
        </Body3>
        <CloseWindowButton
          margin="0 0 7px 5px"
          width={10}
          stroke={2}
          color={colors.red}
          handleClick={() => form.removeSetupFilter('FTFC')}
        />
      </header>
      <div className={style.body}>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Add Time Frame
        </Body3>
        <div className={style.inputs}>
          <BoxInput
            width="40px"
            fontSize={fontSizes.body3}
            backgroundColor={colors.black}
            value={durationInput}
            setValue={(value) => setDurationInput(value)}
            symbol=""
            direction="left"
          />
          <select
            style={{ fontSize: fontSizes.body3 }}
            value={timeUnitSelection}
            className={style.select}
            onChange={({ target }) => setTimeUnitSelection(target.value)}
          >
            {Object.keys(timeUnitMap).map((timeUnit) => {
              return (
                <option key={timeUnit} value={timeUnit}>
                  {timeUnitMap[timeUnit]}
                </option>
              );
            })}
          </select>
          <IncrementButton
            paddingPercent={10}
            width={15}
            buttonWidth="21px"
            color={colors.lightGrey}
            backgroundColor={colors.blue}
            stroke={1}
            handleClick={() => {
              form.setupFilters.FTFC.addTimeFrame({
                candleDuration: durationInput,
                timeUnit: timeUnitSelection,
              });
            }}
          />
        </div>
        <div className={style.timeFrameContainer}>
          {form.setupFilters['FTFC'].timeFrames.map((timeFrame) => (
            <div
              key={timeFrame.candleDuration + timeFrame.timeUnit}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
              }}
            >
              <TimeFrameBox timeFrame={timeFrame} />
            </div>
          ))}
        </div>
        <TextButton
          clickHandler={() => form.setupFilters.FTFC.clearTimeFrames()}
          color={colors.lightGrey}
          backgroundColor={colors.blue}
          fontSize="small"
        >
          Clear Time Frames
        </TextButton>
      </div>
    </div>
  );
});
